import { ReactNode } from 'react';
import { useHelpDrawerOptional } from '@/components/help/HelpDrawerContext';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  // helpSlug, when set, renders a "Learn how ->" link beneath the body that
  // opens the contextual help drawer scrolled to that article.
  helpSlug?: string;
}

export function EmptyState({ title, description, action, helpSlug }: EmptyStateProps) {
  const help = useHelpDrawerOptional();
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 border border-dashed border-dash-border rounded-lg bg-dash-surface/40 text-center">
      <h3 className="text-base font-semibold text-dash-primary mb-2">{title}</h3>
      {description ? (
        <p className="text-sm text-dash-secondary max-w-md">{description}</p>
      ) : null}
      {helpSlug && help ? (
        <button
          type="button"
          onClick={() => help.openDrawer(helpSlug)}
          className="mt-3 text-sm text-accent no-underline hover:underline"
        >
          Learn how -&gt;
        </button>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
